export default __webpack_public_path__ + "static/media/starclusters.f02448f1.png";